import { Bar, Bubble, Doughnut, Line, Pie, PolarArea, Radar, Scatter } from 'vue-chartjs'
import { Chart } from 'chart.js'
import ChartJSPluginAnnotation from 'chartjs-plugin-annotation'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import ChartJSPluginNoDataBackground from '@/libs/chart.js/ChartJSPluginNoDataBackground'
import ChartJSPluginLegendEvent from '@/libs/chart.js/ChartJSPluginLegendEvent'
import ChartRoundedBarChart from '@/libs/chart.js/Chart.RoundedBarChart'
export default function createVueChart (type) {
    const chart = {
        Bar,
        Bubble,
        Doughnut,
        Line,
        Pie,
        PolarArea,
        Radar,
        Scatter
    }
    return {
        extends: chart[type],
        props: {
            data: {
                type: Object,
                default: null
            },
            options: {
                type: Object,
                default: null
            },
            plugins: {
                type: Array,
                default: null
            },
            styles: {
                type: Object,
                default: null
            },
            width: {
                type: Number,
                required: false,
                default: 0
            },
            height: {
                type: Number,
                required: false,
                default: 0
            }
        },
        computed: {
            locale () {
                return this.$i18n.locale
            },
            theme () {
                return this.$store.getters['appConfig/theme']
            }
        },
        created () {
            // Chart.defaults.global.defaultFontSize = 12
            Chart.defaults.global.defaultFontColor = '#B5B5B5'
            Chart.defaults.global.defaultFontFamily = "'Public Sans', 'Noto Sans KR', 'Apple SD Gothic Neo', Sans-serif"
            if (type === 'Bar') ChartRoundedBarChart(Chart)
        },
        mounted () {
            Chart.plugins.register(ChartJSPluginAnnotation)
            Chart.plugins.register(ChartJSPluginDatalabels)
            Chart.plugins.register(ChartJSPluginNoDataBackground)
            Chart.plugins.register(ChartJSPluginLegendEvent)
            if (this.$refs.canvas) {
                this.$refs.canvas.style.width = `${this.width}px`
                this.$refs.canvas.style.height = `${this.height}px`
            }
            this.renderChart(this.data, this.options, this.plugins, this.styles)
        },
        onUnmounted () {
            Chart.plugins.unregister(ChartJSPluginAnnotation)
            Chart.plugins.unregister(ChartJSPluginDatalabels)
            Chart.plugins.unregister(ChartJSPluginNoDataBackground)
            Chart.plugins.unregister(ChartJSPluginLegendEvent)
        },
        watch: {
            data: {
                handler (value, oldValue) {
                    this.renderChart(value, this.options, this.plugins, this.styles)
                }
            },
            locale: {
                handler (value, oldValue) {
                    if (this.$data._chart) {
                        this.$data._chart.destroy()
                    }
                    this.renderChart(this.data, this.options, this.plugins, this.styles)
                }
            },
            theme: {
                handler (value, oldValue) {
                    if (this.$data._chart) {
                        this.$data._chart.destroy()
                    }
                    this.renderChart(this.data, this.options, this.plugins, this.styles)
                }
            }
        }
    }
}
